<template>
    <dropdown-confirmation
            size="lg"
            direction="left"
            triggerBtnClass="btn-light"
            triggerBtnHtml='<i class="fa fa-exchange"></i>&nbsp;&nbsp;Merge Account'
            confirmBtnClass="btn-primary"
            confirmBtnHtml='<i class="fa fa-check"></i>&nbsp;&nbsp;Merge Account'
            @confirm="mergeAccount"
    >
        <slot>
            <div style="width: 45%; font-weight: 400; display: inline-block; vertical-align: top; padding: 0 10px 0 0; ">
                <p>Choose an account to merge with:</p>
                <label>Name</label>
                <input type="text" class="form-control" @keyup="searchAccounts" v-model="merge.name" />
                <br />
                <label>Carrier</label>
                <input type="text" class="form-control" @keyup="searchAccounts" v-model="merge.carrier_name" />
            </div><div style="width: 55%; font-weight: 400; display: inline-block; vertical-align: top; padding: 0 0 0 0px; overflow-y:scroll; height: 175px; border: 1px solid #e2e2e2;">
            <div v-for="account in accounts" class="merge-result-row" :class="{active: account.account_id == merge_account_id}"  @click="setMergeAccount(account)">
                <div>{{account.name}}</div>
            </div>

        </div>

        </slot>
    </dropdown-confirmation>
</template>

<script type="text/babel">
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    export default {
        name:'MergeAccounts',
        data:function(){
            return{
                merge: {
                    name: '',
                    carrier_name: ''
                },
                accounts: [],
                merge_account_id: ''
            }
        },
        components:{
            DropdownConfirmation
        },
        methods:{
            setMergeAccount(account){
                this.merge_account_id = account.account_id;
            },
            searchAccounts(search){
                if(!this.merge.name.length){
                    this.accounts = [];
                    return null;
                }
                var data = {
                    search:{
                        name: this.merge.name,
                        carrier_name: this.merge.carrier_name
                    },
                    columns:[
                        'name',
                        'carrier_name'
                    ]
                }

                this.$send(this, 'accounts', data).then(r => {
                    this.accounts = r.accounts
                });
            },
            mergeAccount(){

                if(!this.merge_account_id) return false;

                this.$emit('input', this.merge_account_id)

            },
        }


    }

</script>

<style scoped>
    .merge-result-row{
        padding: 10px;
        cursor: pointer;
        border-bottom: 1px solid #e2e2e2;
    }
    .merge-result-row.active{
        background-color: #f5f5f5;
    }
</style>


// WEBPACK FOOTER //
// MergeAccount.vue?4b93dde9